import { Injectable } from '@angular/core';
import { InvoiceWriteoffApiService } from '@cms/apis';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { InvoiceWriteoffAction } from '../actions';

@Injectable()
export class InvoiceWriteoffEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(InvoiceWriteoffAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => InvoiceWriteoffAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: InvoiceWriteoffApiService, private _actions$: Actions, private _store: Store) {}
}
